export default __webpack_public_path__ + "static/media/nail.71d94bd5.png";